// ui
import { Icon, IconProps } from "@chakra-ui/react";

export const ShareIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.887 7.78089C13.0769 7.58042 13.3934 7.57186 13.5939 7.76177L15.9797 10.0219C15.9799 10.0222 15.9802 10.0224 15.9805 10.0227C16.3401 10.3615 16.3398 10.9067 15.9797 11.2453L13.5924 13.4891C13.3912 13.6782 13.0748 13.6684 12.8857 13.4672C12.6965 13.266 12.7063 12.9496 12.9076 12.7604L15.1708 10.6331L12.9061 8.48774C12.7057 8.29783 12.6971 7.98136 12.887 7.78089Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 15.8748C7.75 12.6772 10.4193 10.1248 13.6875 10.1248H15.5C15.7761 10.1248 16 10.3486 16 10.6248C16 10.9009 15.7761 11.1248 15.5 11.1248H13.6875C10.9382 11.1248 8.75 13.2623 8.75 15.8748C8.75 16.1509 8.52614 16.3748 8.25 16.3748C7.97386 16.3748 7.75 16.1509 7.75 15.8748Z"
      fill="currentColor"
    />
  </Icon>
);
